module.exports = __webpack_public_path__ + "static/media/blog_image_3.09552e7b.webp";